import { apiClient } from "../api/apiclient"

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });

    export const getApplicationConfiguration = (token) =>
        apiClient.get("/api/application-configurations/get-all", {
            headers: { Authorization: `Bearer ${token}` },
        });

export const postApplicationConfiguration = (applicationConfigurationDTO, token) =>
    apiClient.post("/api/application-configurations/create", applicationConfigurationDTO, {
        headers: { Authorization: `Bearer ${token}` },
    });


    export const updateApplicationConfiguration = (id, updatedConfig,token) =>
        apiClient.put(`/api/application-configurations/${id}`, updatedConfig,   {
            headers: { Authorization: `Bearer ${token}` },
          
        }
    );